import { CloseOutlined, FilterOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Drawer, Grid, Modal, Radio, Row, Spin } from 'antd';
import * as Api from 'api';
import FilterImage from 'components/filterImage';
import GalleryMediaBox from 'components/GalleryMediaBox';
import ImageCard from 'components/imageCard';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link, useHistory, useParams } from 'react-router-dom';
import useApi from 'redux/api/api.hook';
import useAuth from 'redux/auth/auth.hook';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

interface ParamTypes {
  image_filter: string
}

const ImagePage = () => {
  const { auth: { profile } } = useAuth();
  const { image_filter } = useParams<ParamTypes>();
  const { md, xs } = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [activeCardIndex, setActiveCardIndex] = useState(-1);
  const { images, filterOptions, setImages, setFilterOption, showLeftFilter, setShowLeftFilter } = useApi();
  const [cameraArr, setCameraArr] = useState<any[]>([]);
  const [cameraGroups, setCameraGroups] = useState<any[]>([]);
  const history = useHistory();
  let groupImageDate = '';

  const getImages = (start, more) => {
    setLoading(true);
    console.log(filterOptions);
    let category_api = filterOptions.category;
    if (filterOptions.antlered == '1') {
      category_api = 'Deer (Antlered)';
    }
    if (filterOptions.video_image == null) {
      setFilterOption({ ...filterOptions, video_image: '' });
    }
    const params = {
      cameras: (filterOptions.camera_id == null || filterOptions.camera_id == 0) ? [] : [filterOptions.camera_id],
      categories: (category_api == null || category_api == 'all') ? [] : [category_api],
      tags: filterOptions.tag == 'All' ? [] : [filterOptions.tag],
      fromDate: filterOptions.fromDate == null ? '' : filterOptions.fromDate,
      toDate: filterOptions.toDate == null ? '' : filterOptions.toDate,
      sort: filterOptions.sort,
      start,
      length: 36,
      video_only: (filterOptions.video_only == null || !filterOptions.video_only) ? 0 : 1,
      favorite_only: (filterOptions.favorite_only == null || !filterOptions.favorite_only) ? 0 : 1,
    };

    Api.IMAGE_LOAD_ALL(params).then(((res: any) => {
      if (more) {
        setImages(images.concat(JSON.parse(res.text).data));
      } else {
        setImages(JSON.parse(res.text).data);
      }
      setLoading(false);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
    setStartIndex(start);
  };

  const http_favorite_change = (index, favorite) => {
    setLoading(true);
    const params = {
      id: index,
      value: favorite,
    };

    Api.IMAGE_FAVORITE_CHANGE(params).then(((res: any) => {
      setLoading(false);
    })).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  useEffect(() => {
    if (images.length <= 0) {
      console.log('hide');
      hideModal();
    }
  }, [images]);

  useEffect(() => {
    if (filterOptions) {
      reloadPage();
    }
  }, [filterOptions]);

  const onScroll = () => {
    console.log('onScroll');
    getImages(startIndex + 36, true);
  };

  const hideModal = () => {
    setActiveCardIndex(-1);
  };

  const reloadPage = () => {
    setImages([]);
    getImages(0, false);
  };

  const selectCard = (index, value) => {
    images[index].selected = value;
    setImages(images);
  };

  const changeFavorite = (index, isFavorite) => {
    images[index].favorite = isFavorite;
    setImages(images);
    http_favorite_change(images[index].id, isFavorite);
  };

  const handleRightFilter = (willShow) => {
    setShowLeftFilter(willShow);
  };

  const changecategory = (e) => {
    const val = e.target.value;
    if (val == 'deer') {
      setFilterOption({ ...filterOptions, category: val, antlered: '0' });
    } else {
      setFilterOption({ ...filterOptions, category: val });
    }
    history.push(`/image/${val}`);
  };

  useEffect(() => {
    if (profile) {
      // get cameras and tags
      Api.CAMERAS_GROUPS().then(((res: any) => {
        const result = JSON.parse(res.text);
        setCameraArr(result.cameras);
        setCameraGroups(result.cameraGroups);
      })).catch((error: any) => {
        console.log('error ===>', error);
      });
    }
  }, [profile]);

  const onLastPage = () => {
    console.log('onLastPage');
    getImages(startIndex + 36, true);
  };

  return (
    <>
      <Row>
        {md && (
          <Col md={6} xxl={4}>
            <div className={classes.imageFilter}>
              <FilterImage
                cameraGroups={cameraGroups}
                cameraArr={cameraArr}
                imageFilter={image_filter}
                reloadPage={() => reloadPage()}
              />
            </div>
          </Col>
        )}
        {!md && (
          <Drawer
            title="Filter & Edit"
            width={300}
            onClose={() => handleRightFilter(false)}
            visible={showLeftFilter}
            zIndex={900}
            handler={
              (
                <div className={classes.drawerHandle}>
                  {
                    showLeftFilter ? <CloseOutlined onClick={() => handleRightFilter(false)} /> : <FilterOutlined onClick={() => handleRightFilter(true)} />
                  }
                </div>
              )
            }
          >
            <FilterImage
              cameraGroups={cameraGroups}
              cameraArr={cameraArr}
              imageFilter={image_filter}
              reloadPage={() => reloadPage()}
            />
          </Drawer>
        )}
        <Col md={18} xs={24} xxl={20}>
          <Radio.Group defaultValue={image_filter} buttonStyle="solid" className={classes.categoryGroup} onChange={changecategory}>
            <Row>
              <Col span={md ? 3 : 6} key={1}><Radio.Button className={classes.categoryBtn} value="all">All</Radio.Button></Col>
              <Col span={md ? 3 : 6} key={2}><Radio.Button className={classes.categoryBtn} value="deer">Deer</Radio.Button></Col>
              <Col span={md ? 3 : 6} key={3}><Radio.Button className={classes.categoryBtn} value="hog">Hog</Radio.Button></Col>
              <Col span={md ? 3 : 6} key={4}><Radio.Button className={classes.categoryBtn} value="turkey">Turkey</Radio.Button></Col>
              <Col span={md ? 3 : 6} key={5}><Radio.Button className={classes.categoryBtn} value="people">People</Radio.Button></Col>
              <Col span={md ? 3 : 6} key={6}><Radio.Button className={classes.categoryBtn} value="vehicle">Vehicle</Radio.Button></Col>
              <Col span={md ? 3 : 6} key={7}><Radio.Button className={classes.categoryBtn} value="predator">Predator</Radio.Button></Col>
              <Col span={md ? 3 : 6} key={8}><Radio.Button className={classes.categoryBtn} value="other">Other</Radio.Button></Col>
            </Row>
          </Radio.Group>
          <Spin spinning={loading} size="large" wrapperClassName={classes.content}>
            <InfiniteScroll
              dataLength={images.length}
              next={onScroll}
              hasMore={!loading}
              loader=""
              endMessage={
                (
                  <p style={{ textAlign: 'center' }}>
                    <b>No more images</b>
                  </p>
                )
              }
            >
              <Row className={classes.content}>
                {
                  images.map((e, i) => {
                    const date = e.time.split(' ')[0];
                    if (date == groupImageDate) {
                      return (
                        <Col xs={12} md={6} xxl={4} key={i}>
                          <ImageCard key={i} index={i} detail={e} onClick={(index) => { setActiveCardIndex(index); }} onSelect={(arg) => { selectCard(i, arg); }} onFavorite={(index, isFavorite) => changeFavorite(index, isFavorite)} />
                        </Col>
                      );
                    }
                    groupImageDate = date;
                    return (
                      <React.Fragment key={i}>
                        <Divider key={`Divider${i}`} orientation="left" className={classes.groupDivider}>{moment(groupImageDate).format('MMM D, Y')}</Divider>
                        <Col xs={12} md={6} xxl={4} key={i}>
                          <ImageCard key={i} index={i} detail={e} onClick={(index) => { setActiveCardIndex(index); }} onSelect={(arg) => { selectCard(i, arg); }} onFavorite={(index, isFavorite) => changeFavorite(index, isFavorite)} />
                        </Col>
                      </React.Fragment>
                    );
                  })
                }
              </Row>
            </InfiniteScroll>
          </Spin>
        </Col>
      </Row>
      <div className={classes.containerFloat}>
        <Link to="/imageUpload">
          <Button type="primary" shape="round" size="large" icon={<PlusOutlined />} className="addImageBtn">
            Add images
          </Button>
        </Link>
      </div>
      <Modal
        visible={activeCardIndex > -1}
        onOk={hideModal}
        onCancel={hideModal}
        width={1000}
        className={classes.mediaModal}
        bodyStyle={{ backgroundColor: 'transparent', padding: 0 }}
        footer={null}
        destroyOnClose
      >
        <GalleryMediaBox
          activeIndex={activeCardIndex}
          cameraArr={cameraArr}
          onLastPage={onLastPage}
          onFavorite={(index, isFavorite) => changeFavorite(index, isFavorite)}
        />
      </Modal>
    </>
  );
};

export default ImagePage;
